import { AxiosRequestConfig } from "axios";
import axiosInstance from "@/util/axios";
import { authenticator } from "@/util/authenticator";
import {
    MOCK_ACCOUNT,
    MOCK_USER,
    MOCK_JOINER_BONUS,
    MOCK_CREDIT_INFOS,
    MOCK_SOLD_ITEMS,
    MOCK_CHART_CANDLES,
    MOCK_LEGAL_CONTENT
} from "./mockData";
import {getMockCustomerProfile, getMockEsimData} from "./scenarios";

function mockAdapter(config: AxiosRequestConfig): Promise<any> {
    const url = config.url || "";
    let data: any;

    if (url.startsWith("/activations/customers/profile")) {
        data = getMockCustomerProfile();
    } else if (url.startsWith("/esim/profile")) {
        data = getMockEsimData();
    } else if (url.startsWith("/account")) {
        data = MOCK_ACCOUNT;
    } else if (url.startsWith("/users/current/credit")) {
        data = MOCK_CREDIT_INFOS;
    } else if (url.startsWith("/users/current")) {
        data = MOCK_USER;
    } else if (url.startsWith("/activations/activated-items")) {
        data = MOCK_SOLD_ITEMS;
    } else if (url.startsWith("/analysis/revenue")) {
        data = MOCK_CHART_CANDLES;
    } else if (url.startsWith("/products/joiner-bonus")) {
        data = MOCK_JOINER_BONUS;
    } else if (url.startsWith("/legal-content/")) {
        data = MOCK_LEGAL_CONTENT;
    } else {
        // Return empty success for any unhandled route so the app doesn't crash
        console.warn(`[Mock] No mock defined for: ${url} — returning {}`);
        data = {};
    }

    return Promise.resolve({
        data,
        status: 200,
        statusText: "OK",
        headers: { "content-type": "application/json" },
        config,
        request: {}
    });
}

export function setupMocks(): void {
    if (process.env.VUE_APP_MOCK_MODE !== "true") return;

    console.info("[Mock] Mock mode enabled — all API calls will use local mock data.");

    // Replace the axios adapter so no real HTTP requests are made
    (axiosInstance.defaults as any).adapter = mockAdapter;

    // Allow the router auth guard to pass for authenticated pages
    authenticator.isAuthenticated = async () => true;
    authenticator.getAccessToken = async () => "mock-token";
}
